import { faComment } from "@fortawesome/free-solid-svg-icons";
import { isNumber, isDefinedString, isPositiveNumber } from "et3-type-guards";
import React from "react";
import {
  SEARCH_BY_INPUT_USER_ID,
  USER_SEARCH_BY_ENTRIES_FOR_REFERRAL_CODE_USAGE_PAGE,
  REFERRAL_CODE_USAGE_LIMIT
} from "../../../../constants/picker-entries-constants";
import i18n from "../../../../constants/i18n";
import getReferralCodeStore from "../../../../stores/user-store/referral-code-store";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import ET3Radio from "../../../../core/et3-input/et3-radio";
import Et3TextInput from "../../../../core/et3-input/et3-text-input";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import ET3Div from "../../../../core/et3-div";
import Et3Picker from "../../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../../TypesNEW";

const UserReferralCodeUsageForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const ifSearchTypeUserID =
    getReferralCodeStore().searchByInputForReferralCodeUsage.get() ===
    SEARCH_BY_INPUT_USER_ID;
  const intRefferalCodeSearch = parseInt(
    `${getReferralCodeStore().referralCodeUsageSearchInput.get()}`,
    10
  );

  const isEnabled = ifSearchTypeUserID
    ? isPositiveNumber(intRefferalCodeSearch)
    : isDefinedString(
        getReferralCodeStore().referralCodeUsageSearchInput.get()
      );

  return (
    <React.Fragment>
      <ET3Radio
        options={USER_SEARCH_BY_ENTRIES_FOR_REFERRAL_CODE_USAGE_PAGE}
        value={getReferralCodeStore().searchByInputForReferralCodeUsage.get()}
        onChoose={(value) => {
          getReferralCodeStore().referralCodeUsageSearchInput.set("");
          getReferralCodeStore().setSearchByInputForReferralCodeUsage(
            `${value}`
          );
        }}
        style={{}}
      />
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3TextInput
          size="MEDIUM"
          withShadow={true}
          type={!ifSearchTypeUserID ? "text" : "number"}
          icon={faComment}
          label={getReferralCodeStore().getInputPlaceholderForReferralCodeUsage.get()}
          placeHolder={getReferralCodeStore().getInputPlaceholderForReferralCodeUsage.get()}
          value={getReferralCodeStore().referralCodeUsageSearchInput.get()}
          onChoose={(value) => {
            if (ifSearchTypeUserID) {
              if (!isNumber(value) && !isDefinedString(value)) {
                getReferralCodeStore().referralCodeUsageSearchInput.set(-1);
              } else {
                const intValue = isNumber(value) ? value : parseInt(value, 10);
                getReferralCodeStore().referralCodeUsageSearchInput.set(
                  intValue
                );
              }
            } else {
              getReferralCodeStore().referralCodeUsageSearchInput.set(value);
            }
          }}
          onBlur={() => {}}
          onEnter={async () =>
            await getReferralCodeStore().getUserReferralCodeUsageData()
          }
          style={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("LIMIT")}
          options={REFERRAL_CODE_USAGE_LIMIT}
          value={getReferralCodeStore().referralCodeSelectedLimit.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getReferralCodeStore().setReferralCodeSelectedLimit(value);
          }}
          isMultiple={false}
          style={{}}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        size="LARGE"
        type="GET"
        isEnabled={isEnabled}
        onClick={async () =>
          await getReferralCodeStore().getUserReferralCodeUsageData()
        }
        text="GET"
      />
    </React.Fragment>
  );
});
export default UserReferralCodeUsageForm;
